import classNames from 'classnames'
import React from 'react'
import * as UI from '@brewlogix/blx-ui'
import { useFilterStore } from '../../state/filterStore'
import { Availability } from 'src/types/schema/graphql'
import { parseEnumLabel } from 'src/util/helpers'

const AvailabilityFilter: React.FC = () => {
    const {
        toggleAvailabilityArrowUp,
        setToggleAvailabilityArrowUp,
        setAvailabilityFilter,
        availabilityFilter,
        availabilitySelections,
        setAvailabilitySelections,
        setPage,
        setNextResultsOffset,
    } = useFilterStore()
    const availabilityOptions = Object.values(Availability).map((item) => ({
        label: parseEnumLabel(item),
        value: item,
    }))

    const handleFilterSelection = (item: Availability) => {
        setPage(1)
        setNextResultsOffset(null)
        if (availabilityFilter?.length) {
            if (!availabilityFilter?.includes(item)) {
                setAvailabilityFilter([...availabilityFilter, item])
                setAvailabilitySelections({
                    ...availabilitySelections,
                    [item]: true,
                })
            } else {
                setAvailabilityFilter(availabilityFilter?.filter((brew) => brew !== item))
            }
        } else {
            setAvailabilityFilter([item])
            setAvailabilitySelections({
                ...availabilitySelections,
                [item]: true,
            })
        }
    }

    return (
        <div
            className={classNames(
                'flex flex-col items-start justify-start space-y-2 ',
                toggleAvailabilityArrowUp ? 'mb-6' : 'mb-4'
            )}
        >
            <UI.Button
                label='Availability'
                data-cy='filterAvailability'
                theme='link'
                customClasses='flex flex-row-reverse justify-start text-dark pb-0 pl-0'
                onClick={() => setToggleAvailabilityArrowUp(!toggleAvailabilityArrowUp)}
                size='sm'
            >
                <UI.Icon
                    slug='HeroIcons.ChevronRight'
                    size='sm'
                    customClasses={classNames(
                        toggleAvailabilityArrowUp ? '-rotate-90' : '',
                        'text-gray-300 mr-2 pointer-events-none'
                    )}
                />
            </UI.Button>

            <div
                className={classNames(
                    !toggleAvailabilityArrowUp ? 'hidden' : '',
                    'flex flex-col pl-1'
                )}
            >
                {availabilityFilter &&
                toggleAvailabilityArrowUp &&
                availabilityFilter.length > 0 ? (
                    <div className='flex w-full flex-col'>
                        <UI.Button
                            theme='link'
                            customClasses='pl-0 text-sm flex items-center font-thin '
                            size='sm'
                            onClick={() => setAvailabilityFilter([])}
                        >
                            <UI.Icon
                                slug='HeroIconsSolid.XCircle'
                                theme='link'
                                customClasses='mr-2'
                                size='sm'
                            />
                            Clear
                        </UI.Button>
                    </div>
                ) : (
                    ''
                )}
                {availabilityOptions.map((item, index) => (
                    <div key={`filterOption-${item.label}`} className='flex flex-col'>
                        <UI.InputGroup
                            type='checkbox'
                            id={`filterAvailability-${item.label}`}
                            label={item.label}
                            placeholder={item.label}
                            customClasses='pt-2 input-group--brewknowledge'
                            checked={item.value ? availabilityFilter.includes(item.value) : false}
                            onClick={() => handleFilterSelection(item?.value)}
                        />
                    </div>
                ))}
            </div>
        </div>
    )
}

export default AvailabilityFilter
